/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since 2017.5.26
 */


let {
  isArray
} = T;
let {
  divIcon,
  layerGroup: toLayerGroup,
  marker: toMarker,
  Polyline,
  Polygon,
  Circle,
  latLng: toLatLng,
  Path
} = L;

let editLayer;
let transform;
let globalFeature;
let initEvent = false;


/**
 * 编辑、旋转
 */
Path.include({
  /**
   * 
   */
  createTransform() {
    if (transform) {
      transform.disable();
    }
    //

    transform = this.transform || new L.Handler.PathTransform(this, this.options.transform);
    transform.enable({
      // 只旋转,不缩放
      scaling: false
    });

    //
    let {
      _map: map
    } = this;
    //
    if (!this.transform) {
      this.transform = transform;
      let feature = this;
      //
      map.on('preclick zoomend moveend', () => {
        editLayer.clearLayers();
        feature.transform.disable();
      });
      // 
      feature.dragging && feature.dragging.enable(); //确保可拖动，即使初始化 options.draggable = true，不能确保 dragstart 可触发
      feature.on('dragstart dragend remove', () => {
        editLayer.clearLayers();
        feature.transform.disable();
      })
    }
    globalFeature = this;
    // 
    if (!initEvent) {
      initEvent = true;
      map.on('preclick zoomend moveend', () => {
        if (globalFeature && globalFeature._map && (globalFeature instanceof Polyline || globalFeature instanceof Circle)) {
          globalFeature.bringToBack();
          globalFeature = null;
        }
      });
    }
    //

  },
  /**
   * 绘制编辑拖动点
   * @param v 
   */
  toEdit(e) {
    if (e && e.originalEvent.button !== 0) { //鼠标右键
      return;
    }
    let feature = this;
    let latlngs, onDrag, vLatLngs;
    let {
      _map: map
    } = this;

    // 添加编辑图层
    if (!editLayer || !map.hasLayer(editLayer)) {
      editLayer = toLayerGroup().addTo(map); //右键菜单 this.__drawLayer
    }
    // canvas的旋转交互效果在 transform 这个插件中是比svg差的，后续考虑修改 transform
    feature.createTransform(); //确保可以旋转,经过拖拽之后，transform 需要重新计算
    //确保更新拖拽 ui
    feature.transform._rectShape = null;
    feature.transform.reset();
    //
    let layer = this.editLayer = editLayer;
    layer.clearLayers();
    if (feature instanceof L.Rectangle) {
      latlngs = feature.getLatLngs()[0];
      onDrag = this.onRectPointDrag;
    } else if (feature instanceof Polygon) {
      latlngs = feature.getLatLngs()[0];
      vLatLngs = []
      for (let i = 0, l = latlngs.length, item, next; i < l; i++) {
        item = latlngs[i];
        if (i < l - 1) {
          next = latlngs[i + 1];
        } else {
          next = latlngs[0];
        }
        vLatLngs.push([(item.lat + next.lat) * 0.5, (item.lng + next.lng) * 0.5]);
      }
    } else if (feature instanceof Circle) {
      let bounds = feature.getBounds();
      let center = feature.getLatLng();
      latlngs = [
        [bounds.getNorth(), center.lng],
        [bounds.getSouth(), center.lng],
        [center.lat, bounds.getWest()],
        [center.lat, bounds.getEast()]
      ]
      onDrag = this.onCirclePointDrag;
    } else if (feature.getLatLngs) { //点图元 没有feature.getLatLngs 的方法。目前先按这种方式区分开来。
      latlngs = feature.getLatLngs();
      vLatLngs = [];
      for (let i = 0, l = latlngs.length - 1, item, next; i < l; i++) {
        item = latlngs[i];
        next = latlngs[i + 1];
        vLatLngs.push([(item.lat + next.lat) * 0.5, (item.lng + next.lng) * 0.5])
      }
    }
    //
    onDrag = onDrag || this.onLinePointDrag;
    if (latlngs) {
      let linePointStyle = {
        icon: divIcon({
          className: 'linePoint'
        }),
        draggable: true,
        clickable: false
      }
      latlngs.forEach(value => {
        toMarker(value, linePointStyle)
          .on('drag', onDrag.bind(this))
          .addTo(layer)
          .on('mouseup dragend', e => {
            // 更新拖拽 ui 
            feature.transform._rectShape = null;
            feature.transform.reset();
            feature.fire('edit-end', latlngs);
          }).on('contextmenu', e => { // 点太密集右键菜单出不来

            feature.fire('contextmenu', e);
            //
            T.each(feature._eventParents, parent => {
              parent.fire('contextmenu', T.assign({}, e, {
                layer: feature
              }))
            })
          })
      })
      if (vLatLngs) {
        linePointStyle = T.assign(linePointStyle, {
          icon: divIcon({
            className: 'vlinePoint'
          })
        })
        vLatLngs.forEach((value, index) => {
          let linePoint = toMarker(value, linePointStyle).on('mousedown', e => {
            let {
              latlng
            } = e;
            let latlngs = feature.getLatLngs();
            if (feature instanceof Polygon) {
              latlngs = latlngs[0];
            }
            latlngs.splice(index + 1, 0, latlng);
            feature.setLatLngs(latlngs);
            linePoint.on('drag', e => {
              latlngs[index + 1] = e.latlng;
              feature.setLatLngs(latlngs);
              feature.redraw();
            }).on('mouseup dragend', e => {
              feature.transform._rectShape = null;
              feature.transform.reset(); // 更新拖拽 ui
              this.toEdit();
              feature.fire('edit-end', latlngs);
            })
          }).on('contextmenu', e => {
            //
            feature.fire('contextmenu', e);
            //
            T.each(feature._eventParents, parent => {
              parent.fire('contextmenu', T.assign({}, e, {
                layer: feature
              }))
            })
          })
          layer.addLayer(linePoint);
        })
      }
    }
  },
  /**
   * 线图元进行拖动
   * @param e 
   */
  onLinePointDrag(e) {
    let feature = this;
    if (feature) {
      let points = this.editLayer.getLayers(),
        {
          target,
          latlng
        } = e,
        index = points.indexOf(target),
        latlngs = feature.getLatLngs();
      if (isArray(latlngs[0])) {
        latlngs = latlngs[0]
      }
      let num = latlngs.length,
        last = index === 0 ? num - 1 : index - 1,
        next = (index === num - 1) ? 0 : index + 1,
        vlast = points[last + num],
        vnext = points[next ? (next + num - 1) : points.length - 1]
      last = latlngs[last];
      next = latlngs[next];
      if ((index !== 0 && index !== num - 1) || feature instanceof Polygon) {
        vlast.setLatLng([(last.lat + latlng.lat) * 0.5, (last.lng + latlng.lng) * 0.5])
        vnext.setLatLng([(next.lat + latlng.lat) * 0.5, (next.lng + latlng.lng) * 0.5])
      } else {
        if (index === 0) {
          vnext.setLatLng([(next.lat + latlng.lat) * 0.5, (next.lng + latlng.lng) * 0.5])
        } else {
          vlast.setLatLng([(last.lat + latlng.lat) * 0.5, (last.lng + latlng.lng) * 0.5])
        }
      }
      //
      latlngs[index] = latlng
      feature.setLatLngs(latlngs)
      // feature.redraw();
    }
  },
  /**
   * 线图元进行拖动
   * @param e 
   */
  onCirclePointDrag(e) {
    let feature = this;
    let latlng = e.latlng,
      center = feature.getLatLng(),
      r = latlng.distanceTo(center);
    feature.setRadius(r);
    feature.redraw();
    let bounds = feature.getBounds();
    let north = bounds.getNorth();
    let south = bounds.getSouth();
    let west = bounds.getWest();
    let east = bounds.getEast();
    let points = this.editLayer.getLayers();
    points[0].setLatLng(toLatLng(north, center.lng))
    points[1].setLatLng(toLatLng(south, center.lng))
    points[2].setLatLng(toLatLng(center.lat, west))
    points[3].setLatLng(toLatLng(center.lat, east))
  },
  /**
   * 
   * @param {*} e 
   */
  onRectPointDrag(e) {
    let feature = this;
    let points = this.editLayer.getLayers();
    let {
      target,
      latlng
    } = e;
    let index = points.indexOf(target);
    let latlng2 = points[(index + 2) % 4].getLatLng();
    feature.setBounds(L.latLngBounds(latlng, latlng2));
    //
    latlngs = feature.getLatLngs()[0];
    points[0].setLatLng(latlngs[0])
    points[1].setLatLng(latlngs[1])
    points[2].setLatLng(latlngs[2])
    points[3].setLatLng(latlngs[3])
  },
  /**
   * 
   */
  editEnable(flag) {
    flag = flag === void 0 ? true : flag;
    this.options.editable = flag;
    this.on('click', this.toEdit.bind(this))
  }
})
/**
 * 
 */
L.Path.addInitHook(function () {
  this.options.editable && this.editEnable();
})



// WEBPACK FOOTER //
// ./src/polyfill/Editable.js